import { createSlice } from '@reduxjs/toolkit';

/** Status values for the fragment loading state machine. */
export const FRAGMENT_STATUS = {
	IDLE: 'idle',
	LOADING: 'loading',
	LOADED: 'loaded',
	ERROR: 'error'
};

const initialState = {
	fragments: {}
};

const fragmentsSlice = createSlice({
	name: 'fragments',
	initialState,
	reducers: {
		/* eslint-disable no-param-reassign --
		   RTK's createSlice uses Immer internally, so these "mutations"
		   produce immutable updates. Direct assignment is the intended API. */
		fragmentFetchStarted(state, action) {
			const url = action.payload;
			state.fragments[url] = {
				status: FRAGMENT_STATUS.LOADING,
				html: null,
				scripts: [],
				states: []
			};
		},
		fragmentFetchSucceeded(state, action) {
			const { url, html, scripts = [], states = [] } = action.payload;
			state.fragments[url] = {
				status: FRAGMENT_STATUS.LOADED,
				html,
				scripts,
				states
			};
		},
		fragmentFetchFailed(state, action) {
			const url = action.payload;
			state.fragments[url] = {
				status: FRAGMENT_STATUS.ERROR,
				html: null,
				scripts: [],
				states: []
			};
		}
		/* eslint-enable no-param-reassign */
	}
});

export const {
	fragmentFetchStarted,
	fragmentFetchSucceeded,
	fragmentFetchFailed
} = fragmentsSlice.actions;

export const fragmentsReducer = fragmentsSlice.reducer;

const DEFAULT_ENTRY = {
	status: FRAGMENT_STATUS.IDLE,
	html: null,
	scripts: [],
	states: []
};

export const selectFragment = (state, url) =>
	state.fragments?.fragments?.[url] ?? DEFAULT_ENTRY;

export const selectFragmentStatus = (state, url) =>
	selectFragment(state, url).status;

export const selectFragmentHtml = (state, url) =>
	selectFragment(state, url).html;

/** True while a fragment hasn't yet resolved to LOADED or ERROR. */
export const isFragmentLoading = (status) =>
	status === FRAGMENT_STATUS.IDLE || status === FRAGMENT_STATUS.LOADING;

export default fragmentsSlice;
